import styled from 'styled-components';
import color from 'tinycolor2';
import {
  PageNavItem,
  PageNav,
} from 'components/PageStyles';

export const NavWrapper = styled(PageNav)`
  padding: 0px 22px 15px 19px;
`;

export const SidebarWrapper = styled.div`
  display: flex;
  align-items: left;
  justify-content:center;
  flex-direction: column;
  & nav:first-child {
    background-color: ${(props) => props.theme.themeId === 'extra-light'
    ? props.theme['color.white'] :
    props.theme['color.blackDark']};
    padding-bottom: 0px;
  }
  & div nav:first-child {
    padding-top: 0px;
  }

  @media (max-width: ${(props) => props.theme['media.tablet']}px) {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    transform: ${(props) => props.mobileSidebarOpen ? 'none' : 'translate3d(-100%, 0, 0)'};
    z-index: 4000;
  }
`;

export const IconLeft = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
  color: ${(props) => props.active ? props.theme['color.primary'] : props.theme['color.text.light']};
`;

export const LineBreakNewUX = styled.hr`
  background:  ${(props) => props.theme.themeId === 'extra-light' ? color(props.theme['color.greyDark']).setAlpha(0.8).toString() : 
    props.theme['color.blackLighter']};
  height: 1px ;
  width : 100%;
  padding: 0px;
  opacity: 0.12;
  margin-top: 17px;
  margin-bottom: 15px;
`;

export const Nav = styled(PageNavItem)`
  justify-content: left;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  min-height: 38px;
  height: auto;
  white-space: unset;
  word-wrap: break-word;
  color: ${(props) => props.theme['color.text.body']};

  &:focus-visible {
    outline: none;
    border: 3px solid ${(props) => props.theme['color.blueLight']};
  }
  
  &:focus {
    border-radius: 8px;
  }

  &:hover {
    color: ${(props) => props.theme['color.blackLighter']};
    cursor: pointer;
    background: ${(props) => props.theme.themeId === 'extra-light' ? props.theme['color.greyLighter'] : 
    props.theme['color.greyDarker']};
    border-radius: 8px;
  }

  ${(props) => props.active && `
    background: ${props.theme.themeId === 'extra-light' ? props.theme['color.greyLighter'] : 
    props.theme['color.greyDarker']};
    border-radius: 8px;
    color: ${props.theme['color.blackLighter']};

    &:hover {
      cursor: default;
      background: none;
    }
  `}
`;


